import axios from "axios";
import config from "../config"; // Import your config module
import { deleteApi, getApi, postApi } from "../pages/AppApis";
import { toast } from "react-toastify";
import { showErrorToast } from "../pages/utils";

// Function to delete a favorite property
export const deleteFavoriteFromProperties = async (authUser, propertyId) => {
    const raw = JSON.stringify({
        listing_id: propertyId,
    });
    const response = await deleteApi("/property-services/favorite_property", raw);

    if (response?.error === 401) {
        // throw new Error(data.error);
        return 401;
    } else if (!response.response) {
        return response?.error || "Internal Server Error";
    } else {
        const favoriteData = response.response;
        return favoriteData || [];
    }
};

// Function to add a favorite property
export const addFavoriteToProperties = async (authUser, propertyId) => {
    const raw = JSON.stringify({
        property_id: propertyId,
    });

    const response = await postApi("/user/properties/favorite", raw);

    if (response?.error === 401) {
        // throw new Error(data.error);
        return 401;
    } else if (!response.response) {
        return response?.error || "Internal Server Error";
    } else {
        const data = response.response;
        return data || [];
    }
};

// Function to fetch favorite property IDs
export const fetchFavoritePropertyIds = async (authUser) => {
    const response = await getApi("/user/properties/favorite");

    if (response?.error === 401) {
        // throw new Error(data.error);
        return 401;
    } else if (!response.response) {
        return response?.error || "Internal Server Error";
    } else {
        const data = response.response;
        return data || [];
    }
};
// Function to fetch favorite property
export const fetchFavoriteProperties = async (authUser, currentPage) => {
    const page = currentPage && !isNaN(currentPage) ? currentPage : 1;
    const response = await getApi("/property-services/favorite_property?page=" + page);

    if (response?.error === 401) {
        // throw new Error(data.error);
        return 401;
    } else if (!response.response) {
        return response?.error || "Internal Server Error";
    } else {
        const data = response.response;
        return data || [];
    }
};

// Function to fetch properties data
export const fetchPropertiesData = async () => {
    const response = await postApi("/user/properties", {});
    if (response.response) {
        return response.response;
    } else if (response.error) {
        return response.error;
    }
};

const getUserProfile = async () => {
    try {
        const response = await getApi(`/user/profile`);
        if (response.error) {
            showErrorToast(response?.error || "Error fetching user profile", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            return response.error;
        } else {
            // setUserInfo(response);
        }
    } catch (err) {
        showErrorToast(`Error fetching user profile: ${err}`);
    }
};

export const getAccessToken = async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    const token = refreshToken ? refreshToken.replace(/^"|"$/g, "") : "";

    if (token) {
        try {
            const response = await getApi("user/refresh_token", token);

            if (response?.data) {
                const { access_token, refresh_token: newRefreshToken } = response.data;
                await localStorage.setItem("authUser", JSON.stringify(access_token));
                if (newRefreshToken) {
                    await localStorage.setItem("refreshToken", JSON.stringify(newRefreshToken));
                }
                // return await checkToken(access_token);

                await getUserProfile();
                // setIsSignedIn(true);
            }
        } catch (err) {
            showErrorToast(`Token refresh failed: ${err}`, {
                autoClose: 3000,
                pauseOnHover: false,
            });
            // setIsSignedIn(false);
        }
    } else {
        // setIsSignedIn(false);
    }
};

// Function to check if the token is valid
export const checkToken = async () => {
    try {
        const tokenResponse = await getApi("/user/validate_token");

        if (tokenResponse?.error) {
            return tokenResponse.error;
        } else if (tokenResponse.response) {
            const tokenData = tokenResponse.response;
            return { tokenData, success: true };
        }
    } catch (error) {
        console.error("Token validation error:", error);

        return { success: false };
    }
};

export const validateTokenAPI = async (token) => {
    try {
        const response = await axios.post(
            `${config.get("API_URL")}/user/validate_token`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.status === 200; // Assume that a 200 status code means the token is valid
    } catch (error) {
        console.error("Error validating token:", error);
        return false; // Token is not valid if an error occurs
    }
};

// Function to refresh the token
export const refreshTokenAPI = async (oldToken) => {
    try {
        const response = await axios.post(
            `${config.get("API_URL")}/user/refresh_token`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${oldToken}`,
                },
            }
        );
        return response.data.newToken; // Adjust based on your API response structure
    } catch (error) {
        return null; // Return null if unable to refresh
    }
};
